export enum LEGACY_COOKIE {
  REHIRE = 'INACTIVE',
}
